import { Link } from "react-router-dom";
import { useObserver, useSubtree } from "subtree.js/react";
import { RegisterActions, RegisterState } from "./register-model";

export function RegisterPage() {
  const state = useSubtree(RegisterState);
  const actions = useSubtree(RegisterActions);
  const observer = useObserver();
  const draft = observer.watch(state.draft);
  const error = observer.watch(state.error);
  const loading = observer.watch(state.busy);

  return (
    <div className="flex min-h-screen items-center justify-center bg-app p-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold">
            Hobby<span className="text-accent">Scan</span>.Pro
          </h1>
          <p className="mt-1 text-muted">Create your account</p>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            void actions.submit();
          }}
          className="panel space-y-5 p-8"
        >
          {error && <p className="note note-danger text-danger">{error}</p>}

          <div>
            <label htmlFor="name" className="label">
              Full name
            </label>
            <input
              id="name"
              type="text"
              required
              autoComplete="name"
              value={draft.name}
              onChange={(e) => actions.setName(e.target.value)}
              placeholder="Jane Doe"
              className="field"
            />
          </div>

          <div>
            <label htmlFor="email" className="label">
              Email
            </label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              value={draft.email}
              onChange={(e) => actions.setEmail(e.target.value)}
              placeholder="you@example.com"
              className="field"
            />
          </div>

          <div>
            <label htmlFor="password" className="label">
              Password
            </label>
            <input
              id="password"
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={draft.password}
              onChange={(e) => actions.setPassword(e.target.value)}
              placeholder="At least 8 characters"
              className="field"
            />
          </div>

          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Creating account…" : "Create account"}
          </button>

          <div className="flex items-center gap-3">
            <span className="h-px flex-1 bg-line" />
            <span className="text-xs text-faint">or</span>
            <span className="h-px flex-1 bg-line" />
          </div>

          <button
            type="button"
            onClick={() => void actions.continueWithGoogle()}
            disabled={loading}
            className="btn-secondary w-full"
          >
            Continue with Google
          </button>

          <button
            type="button"
            onClick={() => void actions.continueWithApple()}
            disabled={loading}
            className="btn-secondary w-full"
          >
            Continue with Apple
          </button>
        </form>

        <p className="mt-4 text-center text-sm text-muted">
          Already have an account?{" "}
          <Link to="/login" className="font-medium text-accent hover:underline">
            Sign in
          </Link>
        </p>

        <p className="mt-6 text-center text-xs text-faint">
          By creating an account you agree to our{" "}
          <Link to="/privacy" className="hover:underline">
            Privacy Policy
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
